export const paymentMethodLabel = {
  'PAYPAL': 'PayPal',
  'CHECK': 'Check',
  'ACH': 'Direct Deposit / ACH',
  'WIRE': 'Wire Transfer'
}

export const paymentUUID = {
  PAYPAL: 'paypalUUID',
  CHECK: 'checkUUID',
  ACH: 'achUUID',
  WIRE: 'wireTransferUUID'
}

export const bankAccountType = {
  BUSINESS_CHECKING: 'Business checking',
  BUSINESS_SAVINGS: 'Business Savings',
  PERSONAL_CHECKING: 'Personal checking',
  PERSONAL_SAVINGS: 'Personal Savings'
}

export const businessTypeOptions = [
  { name:'International Company', value:'INTERNATIONAL_CORPORATION' },
  { name:'International Vendor', value:'INTERNATIONAL_VENDOR' }
]

export const businessTypes = {
  INTERNATIONAL_CORPORATION: 'International Company',
  INTERNATIONAL_VENDOR: 'International Vendor'
}

export const formDefault = {
  'PAYPAL':  {paypalUserName: '', preferredPayment: false},
  'ACH': { 
    bankAccountType: '', bankName: '', accountName: '', routingCode: '', accountNumber: '',
    w9Form: null, w9FormUpdateDateTime: '', w9FormName: '', preferredPayment: false
  },
  'WIRE': {
    accountName: '', bankCity: '', bankCountry: '', bankName: '', 
    bankRegion: '', bankStreetAddress: '', bankZipCode: '', businessType: '', iban: '', swift: '',
    w8BENEForm: null, w8BENEFormLink: '', w8BENEFormName: '', w8BENEFormUpdateDateTime: '', 
    w8BENForm: null, w8BENFormLink: '', w8BENFormName: '', w8BENFormUpdateDateTime: '',
    preferredPayment: false},
  'CHECK': {
    payTo: '', paymentStreetAddress: '', city: '', zipCode: '', state: '', country: '', 
    w9Form: null, w9FormUpdateDateTime: '', w9FormName: '', preferredPayment: false
  }
}

export const saveFormResultMessage = {
  'PAYPAL': {
    success: 'Your PayPal information has been saved',
    error: 'There was an issue saving your paypal data'
  },
  'ACH': {
    success: 'We saved your direct deposit information!!!',
    error: 'Please check your network, we could not process your direct deposit form'
  },
  'CHECK': {
    success: 'Check information updated Successfully',
    error: 'We could not process your check information'
  },
  'WIRE': {
    success: 'You have saved your wire transfer information',
    error: 'There was an issue updating your wire transfer information'
  }
}